import { gql } from '@apollo/client';

export const SEARCH_FOR_MY_SCHOOL = gql`
  query searchForMySchool($searchTerms: String!) {
    searchAcademicGroups(searchTerms: $searchTerms) {
      schools {
        schoolId
        schoolName
        districtId
        districtName
        gradeLevels
        city
        postalCode
      }
    }
  }
`;
